export const DIFFERIMENT_INVOICES_TITLE = 'Habitat 99 | Diferimiento | Facturas';
